import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class IBDialogContainerProps extends Vue {

	@Prop({ type: Boolean, default: false })
	readonly persistent!: boolean

	@Prop({ type: Boolean, default: false })
	readonly fullWidth!: boolean

	@Prop({ type: Boolean, default: true })
	readonly animation!: boolean

	@Prop({ type: Boolean, default: false })
	readonly withoutShadow!: boolean

	@Prop({ type: Boolean, default: false })
	readonly light!: boolean

	@Prop({ type: Boolean, default: false })
	readonly alignStart!: boolean

	@Prop({ type: Boolean, default: false })
	readonly fullDialogContent!: boolean

	@Prop({ type: Number, default: 300 })
	readonly animationTime!: number

}